import { render } from "./TextInputForEditor.vue?vue&type=template&id=99c455e4&ts=true"
import script from "./TextInputForEditor.vue?vue&type=script&lang=ts"
export * from "./TextInputForEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__